export default function pushAdobeDataLayer(
  data: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
) {
  window.adobeDataLayer?.push(data);
}

export function pushAdobeDataLayerEcommerce(
  data: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
) {
  window.adobeDataLayer?.push({ payment: null });
  window.adobeDataLayer?.push(data);
}

export function getAdobeTargetOffer<Data>(
  mbox: string,
  params?: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<Data> {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!window._satellite) {
      reject(new Error('No satellite'));
    }
    // eslint-disable-next-line no-underscore-dangle
    window._satellite?.targetCall(mbox, params || null, (content) => {
      if (content === 'No Result') {
        reject(new Error('No result'));
      }
      resolve(content as Data);
    });
  });
}

export function isAdobeTargetUserIdAssigned() {
  // eslint-disable-next-line no-underscore-dangle
  return !!window._satellite?.adobeTargetUserIdAssigned;
}
